import { render } from "./TagSearchResult.vue?vue&type=template&id=ac4e8b3a"
import script from "./TagSearchResult.vue?vue&type=script&lang=js"
export * from "./TagSearchResult.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__